import React from 'react';
import { Button } from 'flowbite-react';
import classNames from 'classnames';
import moment from 'moment';
import { DayTimeSlot, SlotTime } from 'types';

type Props = {
	selectedDaySlot?: DayTimeSlot;
	selectedTimeSlot?: SlotTime;
	setSelectedTimeSlot: (value: any) => void;
};

export const TimeSelection = ({ selectedDaySlot, selectedTimeSlot, setSelectedTimeSlot }: Props) => {
	return (
		<div className="flex flex-col py-2 sm:max-w-[680px]">
			<p className={`greyish_text_dark_theme dark:text-[#C7C9D9] font-[500] text-[15px]`}>Available Slots</p>
			<div className="scrollPracticeTopics max-w-full overflow-x-auto p-2 pl-0">
				<div className="flex flex-wrap gap-4">
					{' '}
					{/* id="time_selection_scroll_div" */}
					{selectedDaySlot?.slotTimes.map((slotTime: any, index: number) => {
						const isSelected = selectedTimeSlot?.time === slotTime.time;
						return (
							<Button
								key={index}
								className={classNames(
									'whitespace-nowrap',
									{
										'!border-[1px] !border-[#5a85e4] ': isSelected,
									},
									{
										'dark:text-white': isSelected,
									},
								)}
								color={isSelected ? 'dark:[#18222D]' : 'gray'}
								onClick={() => setSelectedTimeSlot(slotTime)}
							>
								{moment(slotTime.time).format('hh:mm a').toUpperCase()}
							</Button>
						);
					})}
				</div>
			</div>
		</div>
	);
};
